<template>
  <v-app id="inspire">
    <alert-modal v-if="getIsInAlert()"></alert-modal>
    <section class="new_login">
      <!-- :style="{'background-image': 'url(' + require('../../assets/img/background_pattern.png') + ')'}"> -->
      <div class="new_login__form_container login__login_content">
        <v-layout
          class="login_content__form"
          row wrap full-width>
          <img class="new_login__logo" :src="require('../../assets/img/logo_fuseaccess.png')" alt="">
          <div class="new_login__logo--title" style="color:#fff;">Central de Monitoreo</div>
          <p
            class="content_form__label"
            :class="{'error_text': error_email !== '' && user.email === ''}">
            Correo electrónico
          </p>
          <input
            type="text"
            class="content_form__input"
            placeholder="Escribe tu correo de acceso"
            v-model="user.email"
            :class="{'error_input': error_email !== '' && user.email === ''}">
          <p
            class="content_form__label"
            :class="{'error_text': error_pass !== '' && user.password === ''}">
            Contraseña
          </p>
          <input
            type="password"
            class="content_form__input"
            placeholder="Escribe tu contraseña"
            v-model="user.password"
            :class="{'error_input': error_pass !== '' && user.password === ''}">
          <h5
            v-if="loadingMessage.length>0"
            style="margin-left:20px;color:#2196f3;font-size:16px;position:relative;"><i>{{ loadingMessage }}</i></h5>
          <v-spacer></v-spacer>
          <button
            class="content_form__button"
            :disabled="loadingMessage.length>0"
            style="border: none !important; font-size: 20px; font-weight: bold;"
            @click="isOnLine?signIn():offlineSignIn()">
            Ingresar
          </button>
          <a href="https://fuseaccess.com/" class="content_form__link no-underline" style="color:#fff;">
            {{ year }} Fusepong. Todos los derechos reservados.
          </a>
        </v-layout>
      </div>
      <div class="new_login__visual_container">
        <section class="new_login__visual_container--principal_image">
          <img src="https://fusepongsolutions.s3.us-west-2.amazonaws.com/monitoring_central/monitoring_central.jpeg"
               alt="">
          <div class="new_login_background"></div>
          <guard-shield class="new_login_background__shield_1"></guard-shield>
          <guard-shield class="new_login_background__shield_2"></guard-shield>
          <guard-shield class="new_login_background__shield_3"></guard-shield>
          <guard-shield class="new_login_background__shield_4"></guard-shield>
          <guard-shield class="new_login_background__shield_5"></guard-shield>
        </section>
      </div>
      <div
        class="new_login__background_elements">
        <img :src="require('../../assets/img/background_pattern.png')" alt="">
      </div>
    </section>
  </v-app>
</template>

<script>
import auth_service from '../../services/auth_service';

export default {
  data: () => ({
    drawer: true,
    user: {
      email: '',
      password: '',
      rut: ''
    },
    error_email: '',
    error_pass: '',
    sublocations: '',
    colors: '',
    users: {
      "1015417203": {name: "Wilson Montoya", category: "One", access_doors: [1, 2, 3]},
      "90020854269": {name: "Andres Fonseca", category: "Premium", access_doors: [5, 6, 7, 8]}
    },
    loadingMessage: '',
    isOnLine: true,
    year: '',
  }),
  props: {
    source: String
  },
  methods: {
    signIn() {
      const self = this;
      try {
        if (this.user.email !== "" && this.user.password !== "") {
          let payload = {attributes: this.user};
          auth_service.singIn({data: this.encrypt(payload).toString()}, undefined, {'X-Device-ID':  this.getDeviceId()}).then(async function (response) {
            if (response.data.meta.authentication_token !== undefined &&
              response.data.meta.authentication_token !== null &&
              response.data.meta.authentication_token !== '') {
              if (response.data.meta.uuid !== undefined &&
                response.data.meta.uuid !== null) {
                self.updateUserIdEncrypt(response.data.meta.uuid);
              }
              if (response.data.data.attributes.user_info_type === "monitor") {
                self.updateUserToken(response.data.meta.authentication_token)
                self.updateUserId(response.data.data.id)
                self.updateUserType("monitor");
                self.updateIsLogin(true);
                self.updateEmail(response.data.data.attributes.email);
                self.$router.push({path: '/monitoring-central'});
              }
            }
          }, function (response) {
            if (response.data.errors && typeof response.data.errors[0].details != "object") {
              if (self.isDesktopApp) {
                self.updateAlertMessage(response.data.errors[0].details)
                self.updateIsInAlert(true)
              } else {
                alert(response.data.errors[0].details)
              }
              self.user.password = ''
            } else {
              if (response.status === 0) {
                this.isOnLine = false;
              }
              let message = []
              for (var key in response.data.errors[0].details) {
                message.push(response.data.errors[0].details[key])
              }
              if (self.isDesktopApp) {
                self.updateAlertMessage(message)
                self.updateIsInAlert(true)
              } else {
                alert(message)
              }
              self.user.password = ''
            }
          });
        } else {
          if (self.isDesktopApp) {
            self.updateAlertMessage('Por favor ingrese usuario y contraseña')
            self.updateIsInAlert(true)
          } else {
            if (this.user.password === "") {
              this.error_pass = 'Por favor ingrese la contraseña';
            }
            if (this.user.email === "") {
              this.error_email = 'Por favor ingrese el usuario';
            }
          }
        }
      } catch (e) {
        alert(e.message);
      }
    }
  },
  mounted() {
    const date = new Date();
    this.year = date.toLocaleDateString('es-CO', {
      year: 'numeric',
    });
  }
}
</script>
